// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__GcyxB","disabled":"FileBtn_disabled__d6Kog","warn":"FileBtn_warn__2sBf9","fade":"FileBtn_fade__b340E"};